import { IconSmartbearLogo } from '@swaggerhub-portal/component-library'
import { useTranslation } from 'react-i18next'

export const BrandingBar = () => {

  const { t } = useTranslation()

  return (
    <div className="mt-[42px]">
      <div 
        className="fixed inset-x-0 bottom-0 h-[42px] border-t bg-neutral-00 dark:bg-neutral-95 border-t-neutral-30 dark:border-t-neutral-80 text-center w-full z-50" 
        data-testid="bottom-branding-bar"
      >
        <div className="flex items-center justify-center pt-[6px]">
          <span className="mr-3 text-neutral-70 dark:text-neutral-40 text-body1">{t('consumer.branding.logoText')}</span>
          <span className="text-[#173647] dark:text-neutral-05"><IconSmartbearLogo /></span>
        </div>
      </div>
    </div>
  )
}